import React from "react";
import "./About_Service.css";

const servicesData = [
  {
    title: "Pickup & Drop-off Service",
    icon: "/assets/images/home/our_services/icon-pickup.png",
  },
  {
    title: "Vehicle Inspection & Valuation",
    icon: "/assets/images/home/our_services/icon-inspection.png",
  },
  {
    title: "Body Repair (Dent & Paint)",
    icon: "/assets/images/home/our_services/icon-repair.png",
  },
  {
    title: "Routine Maintenance",
    icon: "/assets/images/home/our_services/icon-service.png",
  },
  {
    title: "Towing Assistance",
    icon: "/assets/images/home/our_services/icon-towing.png",
  },
  {
    title: "Car Detailing & Clean-up",
    icon: "/assets/images/home/our_services/icon-ride.png",
  },
];

const About_Service = () => {
  return (
    <section className="About_Service">
      <div className="container">
        <p className="about_text">
          Gravity Drive is committed to revolutionizing urban transport by
          providing fast, safe, and affordable rides along with reliable
          delivery services. Our user-friendly app connects you with verified
          drivers and transport partners to ensure a seamless experience every
          time you book. Whether you need a quick ride across town or a trusted
          way to send packages, Gravity Drive is here to move you forward with
          confidence. With a focus on safety, convenience, and transparency, we
          continuously innovate to meet the evolving needs of our users. Join
          millions who trust Gravity Drive for their daily transport & delivery
          needs.
        </p>

        <div className="grids_div">
          {servicesData.map((service, index) => (
            <div className="services_card" key={index}>
              <div className="icon_box">
                <img
                  src={service.icon}
                  alt={service.title}
                  className="icons_img"
                />
              </div>
              <p className="services_title">{service.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About_Service;
